import { useEffect, useMemo, useState } from "react"
import { getNormFromMap } from "@/utils/viewportHelper"

export function useViewportWindow(map) {
  const [tick, setTick] = useState(0)

  useEffect(() => {
    if (!map) return
    const onMove = () => setTick((t) => t + 1)
    map.on("moveend", onMove)
    map.on("zoomend", onMove)
    map.on("resize", onMove)
    map.whenReady(onMove)
    return () => {
      map.off("moveend", onMove)
      map.off("zoomend", onMove)
      map.off("resize", onMove)
    }
  }, [map])

  const norm = useMemo(() => getNormFromMap(map), [map, tick])
  return { norm, viewportTick: tick }
}
